import { useNavigate } from "react-router-dom";
import {
  getAllRealWarehouses,
} from "../../reduxSaga/actions";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import EditRealWarehouse from "../../ui/EditRealWarehouse";
import UtilsFormule from "../../utils/UtilsFormule";
import EditRealDeviseWarehouse from "../../ui/EditRealDeviseWarehouse";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../components/layouts/WithLoader";

const Warehouses = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const availableRealWarehouses = useSelector(
    (state) => state.staff.availableRealWarehouses
  );
  const [availableNotRealWarehouses, setAvailableNotRealWarehouses] = useState(
    []
  );

  const [oldWarehouseData, setOldWarehouseData] = useState();
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const [oldDeviseWarehouseData, setOldDeviseWarehouseData] = useState();
  const [onEditDeviseWarehouse, setOnEditDeviseWarehouse] = useState(false);
  const [showElement, setShowElement] = useState([]);

  useEffect(() => {
    startLoading()
    dispatch(getAllRealWarehouses(0));
    dispatch(getAllRealWarehouses(1));
    WarehouseService.getAllVirtualWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        console.log("getAllVirtualWarehouse", response);
        setAvailableNotRealWarehouses(response.data.success);
      })
      .catch((error) => {
        console.log("error", error);
      }).finally(() => {
        stopLoading()

      })
  }, []);

  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setShowElement(["notConnected"]);
    } else {
      setShowElement(JSON.parse(localStorage.getItem("status")));
    }
  }, []);

  const onAddWarehouseHandler = () => {
    navigate(`/addWarehouse`);
  };
  const onAddStockMinHandler = () => {
    navigate(`/uploadExcelStock`);
    sessionStorage.setItem("stockType", "Min")
  };
  const onAddStockMaxHandler = () => {
    navigate(`/uploadExcelStock`);
    sessionStorage.setItem("stockType", "Max")
  };
  const onEditWarehouseHandler = (
    idWarehouse,
    oldWarehouseName,
    oldWarehouseDesc,
    oldWarehouseReference,
    oldWarehouseManagerId
  ) => {
    let oldWarehouseData = {
      idWarehouse: idWarehouse,
      name: oldWarehouseName,
      description: oldWarehouseDesc,
      warehouseReference: oldWarehouseReference,
      warehouseManagerId: oldWarehouseManagerId,
    };
    setOldWarehouseData(oldWarehouseData);
    setOnEditWarehouse(true);
  };
  const onEditDeviseWarehouseHandler = (
    idWarehouse,
    oldWarehouseName,
    oldWarehouseDesc,
    oldWarehouseReference
  ) => {
    let oldWarehouseData = {
      idWarehouse: idWarehouse,
      oldWarehouseName: oldWarehouseName,
      oldWarehouseDesc: oldWarehouseDesc,
      warehouseReference: oldWarehouseReference,
    };
    setOldDeviseWarehouseData(oldWarehouseData);
    setOnEditDeviseWarehouse(true);
  };



  const onViewProductsHandler = (warehouseId, warehouseName) => {
    sessionStorage.setItem("idWarehouse", warehouseId);
    sessionStorage.setItem("typeDocument", "Warehouse");
    // navigate("/warehouseProducts");
    window.open("/warehouseProducts", "_blank");
  };



  const onViewStatsHandler = (warehouseId, warehouseName,warehouseRef) => {
    sessionStorage.setItem("idWarehouse", warehouseId);
    sessionStorage.setItem("typeDocument", "Warehouse");
     sessionStorage.setItem("warehouseName", warehouseName);
    sessionStorage.setItem("warehouseRef", warehouseRef);
    // navigate("/warehouseProducts");
    window.open("/warehouseStats", "_blank");
  };
  const onViewProductsPriceHandler = (warehouseId, warehouseName) => {
    sessionStorage.setItem("idWarehouse", warehouseId);
   


    sessionStorage.setItem("typeDocument", "Warehouse");
    window.open("/warehouseProductsByPrices", "_blank");
    // navigate("/warehouseProductsByPrices");
  };
  const onViewMouvementHandler = (warehouseId, warehouseName) => {
    sessionStorage.setItem("idWarehouseMouvement", warehouseId);
    sessionStorage.setItem("nameWarehouseMouvement", warehouseName);

    navigate("/warehouseMouvement");
  };
  const [searchText, setSearchText] = useState("");
  const matchesSearch = (element) =>
    `${element.ref || ""} ${element.name || ""}`
      .toLowerCase()
      .includes(searchText.trim().toLowerCase());
  const filteredRealWarehouses = (availableRealWarehouses || []).filter(
    matchesSearch
  );
  const filteredNotRealWarehouses = (availableNotRealWarehouses || []).filter(
    matchesSearch
  );
  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };
  const iconBtn = (title, icon, onClick, extra = {}) => (
    <button
      type="button"
      title={title}
      className={`btn btn-sm ${extra.className || "btn-outline-dark"}`}
      style={{ width: 36 }}
      onClick={onClick}
      {...(extra.modal
        ? { "data-toggle": "modal", "data-target": extra.modal }
        : {})}
    >
      <i className={icon}></i>
    </button>
  );
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-warehouse mr-2"></i>Les dépôts
              </h4>
              <small className="text-muted">
                Gérez vos dépôts, leurs stocks et leurs mouvements
              </small>
            </div>
            <div className="mt-2 mt-sm-0">
              <button
                className="btn btn-outline-dark mr-2"
                onClick={onAddStockMinHandler}
              >
                <i className="fas fa-arrow-down mr-1"></i>
                Stocks Min
              </button>
              <button
                className="btn btn-outline-dark mr-2"
                onClick={onAddStockMaxHandler}
              >
                <i className="fas fa-arrow-up mr-1"></i>
                Stocks Max
              </button>
              {!showElement.includes("WAREHOUSE_MANAGER") && (
                <button className="btn btn-dark" onClick={onAddWarehouseHandler}>
                  <i className="fas fa-plus mr-1"></i>
                  Ajouter un dépôt
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="input-group mb-3" style={{ maxWidth: 360 }}>
                <div className="input-group-prepend">
                  <span className="input-group-text bg-white">
                    <i className="fas fa-search"></i>
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Chercher par référence ou libellé"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>

              <div className="card card-outline card-dark" style={cardStyle}>
                <div className="card-header">
                  <h3 className="card-title">
                    Les dépôts disponibles
                    <span className="badge badge-dark ml-2">
                      {filteredRealWarehouses.length}
                    </span>
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                      title="Réduire"
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body p-0 table-responsive">
                  <table className="table table-hover table-striped mb-0">
                    <thead className="thead-light">
                      <tr className="text-center">
                        <th>Référence</th>
                        <th>Libellé</th>
                        <th>Date de création</th>
                        <th>Devise</th>
                        <th>Modifier</th>
                        <th>Produits</th>
                        <th>Prix</th>
                        <th>Mouvements</th>
                        <th>Stats</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRealWarehouses.length === 0 && (
                        <tr>
                          <td colSpan={9} className="text-center text-muted py-4">
                            Aucun dépôt trouvé
                          </td>
                        </tr>
                      )}
                      {filteredRealWarehouses.map((element) => (
                        <tr key={element.id} className="text-center">
                          <td>
                            <span className="badge badge-light border">
                              {element.ref}
                            </span>
                          </td>
                          <td className="text-left">
                            <strong>{element.name}</strong>
                          </td>
                          <td>{UtilsFormule.formatDate(element.creationDate)}</td>
                          <td>
                            {element.devise !== null ? (
                              <span className="badge badge-dark">
                                {element.devise}
                              </span>
                            ) : (
                              iconBtn(
                                "Définir la devise",
                                "fas fa-pencil-alt",
                                () =>
                                  onEditDeviseWarehouseHandler(
                                    element.id,
                                    element.name,
                                    element.description,
                                    element.ref
                                  ),
                                {
                                  className: "btn-outline-secondary",
                                  modal: "#devise-warehouse",
                                }
                              )
                            )}
                          </td>
                          <td>
                            {iconBtn(
                              "Modifier le dépôt",
                              "fas fa-pencil-alt",
                              () =>
                                onEditWarehouseHandler(
                                  element.id,
                                  element.name,
                                  element.description,
                                  element.ref,
                                  element.warehouseManegerId
                                ),
                              {
                                className: "btn-outline-secondary",
                                modal: "#edit-warehouse",
                              }
                            )}
                          </td>
                          <td>
                            {iconBtn("Voir les produits", "fas fa-folder", () =>
                              onViewProductsHandler(element.id, element.name)
                            )}
                          </td>
                          <td>
                            {iconBtn(
                              "Voir les produits par prix",
                              "fas fa-coins",
                              () =>
                                onViewProductsPriceHandler(
                                  element.id,
                                  element.name
                                )
                            )}
                          </td>
                          <td>
                            {iconBtn(
                              "Voir les mouvements",
                              "fas fa-chart-line",
                              () =>
                                onViewMouvementHandler(
                                  element.id,
                                  element.ref + "-" + element.name
                                )
                            )}
                          </td>
                          <td>
                            {iconBtn("Voir les stats", "fas fa-chart-pie", () =>
                              onViewStatsHandler(
                                element.id,
                                element.name,
                                element.ref
                              )
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="card card-outline card-secondary mt-4" style={cardStyle}>
                <div className="card-header">
                  <h3 className="card-title">
                    Les dépôts systèmes
                    <span className="badge badge-secondary ml-2">
                      {filteredNotRealWarehouses.length}
                    </span>
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                      title="Réduire"
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body p-0 table-responsive">
                  <table className="table table-hover table-striped mb-0">
                    <thead className="thead-light">
                      <tr className="text-center">
                        <th>Référence</th>
                        <th>Libellé</th>
                        <th>Date de création</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredNotRealWarehouses.length === 0 && (
                        <tr>
                          <td colSpan={3} className="text-center text-muted py-4">
                            Aucun dépôt trouvé
                          </td>
                        </tr>
                      )}
                      {filteredNotRealWarehouses.map((element) => (
                        <tr key={element.id} className="text-center">
                          <td>
                            <span className="badge badge-light border">
                              {element.ref}
                            </span>
                          </td>
                          <td className="text-left">
                            <strong>{element.name}</strong>
                          </td>
                          <td>{UtilsFormule.formatDate(element.creationDate)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {onEditDeviseWarehouse && (
        <EditRealDeviseWarehouse
          setOnEditDeviseWarehouse={setOnEditDeviseWarehouse}
          oldDeviseWarehouseData={oldDeviseWarehouseData}
        />
      )}
      {onEditWarehouse && (
        <EditRealWarehouse
          setOnEditWarehouse={setOnEditWarehouse}
          oldWarehouseData={oldWarehouseData}
        />
      )}
    </div>
  );
};
export default withLoader(Warehouses);
